
import './footer.scss';

export default class FooterController {
    constructor() {
        this.eSignatureLink = '/EsignatureDisclosure';
    }
}



// WEBPACK FOOTER //
// ./src/app/common/footer/FooterController.js